import React from 'react';
import { Helmet } from 'react-helmet';
import { observer } from 'mobx-react-lite';
import { JoinMindTrust1 } from '../../components/JoinMindTrust';
import { useAppStore } from 'store/app-store.hook';
import { useLocation } from 'react-router-dom';

export const JoinMindTrust1Page = observer(() => {
  const { joinMindtrustPage } = useAppStore().ui;
  const query = new URLSearchParams(useLocation().search);
  const id = query.get('id');

  React.useEffect(() => {
    if (id) joinMindtrustPage.restoreFromServer(id);
  }, [id, joinMindtrustPage]);

  return (
    <>
      <Helmet>
        <title>Join MindTrust</title>
      </Helmet>
      <JoinMindTrust1
        formValues={joinMindtrustPage.joinMindtrustForm.basicInformation}
        formErrors={joinMindtrustPage.errors?.basicInformation}
        onNext={(basicInformation) => joinMindtrustPage.saveApplicationForm({ basicInformation, nextStep: 2 })}
      />
    </>
  );
});
